import { injectIntl } from 'react-intl';

import ErrorPage from './Error.page';

export default injectIntl(ErrorPage);
